import * as moment from "moment"

export const getYearsForSelect = () => {
  const currentYear = moment().year()
  let years = []
  for (let index = 0; index < 6; index++) {
    years.push((currentYear - index).toString())
  }
  return years
}
